/**
 * Currency utility functions for formatting and displaying currency symbols
 */

/**
 * Get the currency symbol for a given currency code
 * @param {string} currency - Currency code (USD, PLN, EUR, GBP)
 * @returns {string} Currency symbol
 */
export const getCurrencySymbol = (currency) => {
  const currencySymbols = {
    'USD': '$',
    'PLN': 'zł',
    'EUR': '€',
    'GBP': '£',
    'HUF': 'Ft',
    'RON': 'lei',
  };

  return currencySymbols[currency?.toUpperCase()] || currency || '$';
};

/**
 * Format a value with the appropriate currency symbol
 * @param {number} value - The numeric value
 * @param {string} currency - Currency code (USD, PLN, EUR, GBP)
 * @returns {string} Formatted string with currency symbol
 */
export const formatCurrency = (value, currency) => {
  const symbol = getCurrencySymbol(currency);
  const numValue = parseFloat(value) || 0;
  
  // For PLN, HUF, RON (and similar), put symbol after the value
  const symbolAfter = ['PLN', 'HUF', 'RON'];
  if (symbolAfter.includes(currency?.toUpperCase())) {
    return `${numValue} ${symbol}`;
  }
  
  // For USD, EUR, GBP, put symbol before the value
  return `${symbol}${numValue}`;
};

/**
 * Get the primary currency from a list of rewards
 * @param {Array} rewards - Array of reward objects
 * @returns {string|null} Primary currency if all rewards use same currency, null if mixed
 */
export const getPrimaryCurrency = (rewards) => {
  if (!rewards || rewards.length === 0) return null;
  
  const currencies = new Set();
  
  rewards.forEach(reward => {
    if (reward.denominations && reward.denominations.length > 0) {
      // Check denominations array
      reward.denominations.forEach(denom => {
        if (denom.currency) {
          currencies.add(denom.currency);
        }
      });
    } else if (reward.currency) {
      // Check legacy currency field
      currencies.add(reward.currency);
    }
  });
  
  // If only one currency is used, return it
  if (currencies.size === 1) {
    return Array.from(currencies)[0];
  }
  
  // Mixed currencies
  return null;
};













